import {z} from 'zod';

export const CommentsCardInputSchema = z.object({
  comment: z.string().trim(),
});
